import SEO from "@/components/public/SEO";

const FAQS = [
  { q: "Capella Cave ne zaman açılıyor?", a: "Açılışımız 2028 ilkbaharında. Kurucu Misafir Listesi'ne katılarak öncelikli rezervasyon hakkı ve özel avantajlar kazanabilirsiniz." },
  { q: "Şu anda rezervasyon alıyor musunuz?", a: "Henüz değil. Kurucu Misafir Listesi'ne katılan misafirlerimizle önce iletişime geçeceğiz." },
  { q: "Otel nerede?", a: "Göreme, Nevşehir — Kapadokya'nın kalbinde. Nevşehir havalimanına yaklaşık 40 dakika." },
  { q: "Kaç odanız var?", a: "14 butik mağara oda. Hiçbiri diğerine benzemez." },
  { q: "Kapadokya Günlüğü nedir?", a: "Açılışa kadar Kapadokya hakkında editör kalemiyle yazılmış rehberler, mevsim notları ve seyahat hikâyeleri yayımladığımız bölüm." },
  { q: "Bülten ne kadar sıklıkta gelir?", a: "Ayda bir, gürültüsüz. Editör seçkisi ve önemli güncellemeler." },
];

export default function FAQPage() {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <>
      <SEO title="SSS" description="Capella Cave hakkında sıkça sorulan sorular. Açılış, rezervasyon, konum ve daha fazlası." jsonLd={faqSchema} />
      <section className="pt-40 pb-16 max-w-3xl mx-auto px-6 md:px-10">
        <div className="text-[11px] tracking-overline uppercase text-cc-sepia mb-5">Sıkça Sorulan Sorular</div>
        <h1 className="font-serif text-5xl md:text-7xl text-cc-text leading-none mb-8">SSS</h1>
      </section>
      <section className="pb-32 max-w-3xl mx-auto px-6 md:px-10 space-y-8" data-testid="faq-list">
        {FAQS.map((f, i) => (
          <div key={i} className="pb-8 border-b border-cc-border">
            <h2 className="font-serif text-2xl text-cc-text mb-3">{f.q}</h2>
            <p className="text-cc-muted leading-relaxed">{f.a}</p>
          </div>
        ))}
      </section>
    </>
  );
}
